<template>
  <div style="width: 100%">
    <v-card outlined class="px-3 mb-2" width="100%">
      <v-container>
        <h4 style="margin-left: -12px;" class="mb-1">Time</h4>
        <v-row>
          <v-col class="py-0">
            <date-field-widget
                name="startDateModal"
                label="Start Date"
                :dense="true"
                :startDate.sync="startDateInput"
                @date="(date) => {this.startDateInput = date}"
            ></date-field-widget>
          </v-col>
          <v-col class="py-0">
            <clock-widget
                name="startTimeModal"
                :startTime.sync="this.startTimeInput"
                label="Start Time"
                :dense="true"
                @time="(time) => {this.startTimeInput = time}"
            ></clock-widget>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <date-field-widget
                name="endDateModal"
                label="End Date"
                :dense="true"
                :startDate.sync="endDateInput"
                @date="(date) => {this.endDateInput = date}"
            ></date-field-widget>
          </v-col>
          <v-col class="py-0">
            <clock-widget
                name="endTimeModal"
                :startTime.sync="this.endTimeInput"
                label="End Time"
                :dense="true"
                @time="(time) => {this.endTimeInput = time}"
            ></clock-widget>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import ClockWidget from '../../../../core/components/core/ClockFieldWidget'
import DateFieldWidget from '../../../../core/components/core/DateFieldWidget'

export default {
  name: 'EventsTimeCard',
  components: {
    ClockWidget,
    DateFieldWidget
  },
  metaInfo: {
    title: 'Landing',
  },
  props: {
    startDate: {
      type: String,
      default: new Date().toISOString().substr(0, 10)
    },
    endDate: {
      type: String,
      default: new Date().toISOString().substr(0, 10)
    },
    startTime: {
      type: String,
      default: '12:00'
    },
    endTime: {
      type: String,
      default: '13:00'
    }

  },
  data() {
    return {
      startDateInput: this.startDate,
      startTimeInput: this.startTime,
      endDateInput: new Date().toISOString().substr(0, 10),
      endTimeInput: this.endTime,
    }
  },
  watch: {
    endDate(newValue) {
      this.endDateInput = newValue;
    },
    endTime(newValue) {
      this.endTimeInput = newValue;
    },
    startDate(newValue) {
      this.startDateInput = newValue;
    },
    startTime(newValue) {
      this.startTimeInput = newValue;
    },
    endDateInput(newValue) {
      this.$emit('update:endDate', newValue);
    },
    endTimeInput(newValue) {
      this.$emit('update:endTime', newValue);
    },
    startDateInput(newValue) {
      this.$emit('update:startDate', newValue);
    },
    startTimeInput(newValue) {
      this.$emit('update:startTime', newValue);
    }
  },
  methods: {
    outputEndTime() {
      const date = new Date(`${this.endDate}T${this.endTime}:00`);
      this.$emit('endTime', date);
    },
    outputStartTime() {
      const date = new Date(`${this.startDate}T${this.startTime}:00`);
      this.$emit('startTime', date);
    }
  },
  mounted() {

  },
}
</script>
<style>
</style>
